"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryManager = exports.LibraryResource = exports.ResourceStatus = exports.StudyConfigResourceType = exports.ResourceType = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const axios_1 = __importDefault(require("axios"));
const form_data_1 = __importDefault(require("form-data"));
const query_string_1 = __importDefault(require("query-string"));
var ResourceType;
(function (ResourceType) {
    ResourceType["GRAVITON_INSTRUMENTS"] = "GRAVITON_INSTRUMENTS";
    ResourceType["ACTIVITY"] = "ACTIVITY";
    ResourceType["MEDABLE_TASK"] = "MEDABLE_TASK";
    ResourceType["TEMPLATE"] = "TEMPLATE";
    ResourceType["ASSET"] = "ASSET";
    ResourceType["DOMAIN_STUDY_STRING"] = "DOMAIN_STUDY_STRING";
    ResourceType["L10N_MAP"] = "L10N_MAP";
    ResourceType["STUDY_CONFIG"] = "STUDY_CONFIG";
})(ResourceType || (exports.ResourceType = ResourceType = {}));
var StudyConfigResourceType;
(function (StudyConfigResourceType) {
    StudyConfigResourceType["CVR"] = "CVR";
    StudyConfigResourceType["TESTS"] = "TESTS";
    StudyConfigResourceType["TEST_RESULTS"] = "TEST_RESULTS";
})(StudyConfigResourceType || (exports.StudyConfigResourceType = StudyConfigResourceType = {}));
var ResourceStatus;
(function (ResourceStatus) {
    ResourceStatus["DRAFT"] = "DRAFT";
    ResourceStatus["INREVIEW"] = "IN_REVIEW";
    ResourceStatus["PUBLISHED"] = "PUBLISHED";
})(ResourceStatus || (exports.ResourceStatus = ResourceStatus = {}));
class LibraryResource {
    constructor(res, session) {
        this.resource = res;
        this.session = session;
    }
}
exports.LibraryResource = LibraryResource;
class LibraryManager {
    constructor({ libraryUrl, token, axiosInstance }) {
        this.inBrowser = !token;
        this.session =
            axiosInstance || axios_1.default.create({ baseURL: libraryUrl, headers: { Authorization: `Bearer ${token}` } });
    }
    getResourceById(id, resourceType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (id) {
                const path = `v1/${resourceType}/${id}`;
                const { data: { data: resource }, } = yield this.session.get(path);
                return resource;
            }
        });
    }
    getResourceByIdWithURL(id, resourceType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (id) {
                const path = `v1/${resourceType}/${id}?withUrl=true`;
                const { data: { data: resource }, } = yield this.session.get(path);
                return resource;
            }
        });
    }
    getResourceByNameAndVersion(name, version, resourceType) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = query_string_1.default.stringify({ name });
            const path = `v1/${resourceType}?${queryString}`;
            const { data: { data: resourceList }, } = yield this.session.get(path);
            return resourceList.find((v) => v.name === name && v.externalVersion === version);
        });
    }
    getResourceBydataIdentifier() {
        return __awaiter(this, void 0, void 0, function* () {
            const path = `v1/ACTIVITY`;
            yield this.session.get(path);
            return undefined;
        });
    }
    getResource(id, resourceType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (id) {
                const path = `v1/${resourceType}/${id}`;
                const { data: { data: resource }, } = yield this.session.get(path);
                return resource;
            }
        });
    }
    archiveResource(id, resourceType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (id) {
                const path = `v1/${resourceType}/${id}`;
                const { data: { data: resource }, } = yield this.session.delete(path);
                return resource;
            }
        });
    }
    getResources(resourceType, query = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryString = query_string_1.default.stringify(query);
            const path = `v1/${resourceType}${queryString ? '?' + queryString : ''}`;
            const { data } = yield this.session.get(path);
            return data;
        });
    }
    buildFormData(inputResource, filename, zip) {
        const data = new form_data_1.default();
        Object.entries(inputResource).forEach(([key, value]) => {
            let entry = value;
            if (typeof value === 'object') {
                entry = JSON.stringify(value);
            }
            data.append(key, entry);
        });
        data.append('file', zip, { filename });
        return data;
    }
    updateResource(id, resourceType, update, filename, zip) {
        return __awaiter(this, void 0, void 0, function* () {
            let putData;
            let requestConfig = {};
            if (filename && zip) {
                putData = this.buildFormData(update, filename, zip);
                requestConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };
            }
            else {
                putData = update;
            }
            const { data: { data: resource }, } = yield this.session.put(`v1/${resourceType}/${id}`, putData, requestConfig);
            return resource;
        });
    }
    transitionResourceStatus(id, resourceStatus, resourceType) {
        return __awaiter(this, void 0, void 0, function* () {
            const putData = { status: resourceStatus };
            const requestConfig = {};
            const { data: { data: resource }, } = yield this.session.put(`v1/${resourceType}/${id}`, putData, requestConfig);
            return resource;
        });
    }
    createResource(create, resourceType, filename, zip) {
        return __awaiter(this, void 0, void 0, function* () {
            let postData;
            let requestConfig = {};
            if (filename && zip) {
                postData = this.buildFormData(create, filename, zip);
                requestConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };
            }
            else {
                postData = create;
            }
            const { data: { data: resource }, } = yield this.session.post(`v1/${resourceType}`, postData, requestConfig);
            return resource;
        });
    }
    createTranslationResource(parentResourceId, create, resourceType, filename, zip) {
        return __awaiter(this, void 0, void 0, function* () {
            let postData;
            let requestConfig = {};
            if (filename && zip) {
                postData = this.buildFormData(create, filename, zip);
                requestConfig = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };
            }
            else {
                postData = create;
            }
            const { data } = yield this.session.post(`v1/${resourceType}/${parentResourceId}/translations`, postData, requestConfig);
            return data;
        });
    }
    pushActivityBundle(resourceId, activityData, isCustomEcoa) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const url = isCustomEcoa ? '/custom_ecoa/v2/bundle' : '/instrument_bundler/v2/bundle';
            try {
                const modifiedActivityData = JSON.parse(JSON.stringify(activityData));
                modifiedActivityData.screens = modifiedActivityData.screens.filter((screen) => screen.type !== 'placeholder');
                modifiedActivityData.supported_locales = (_a = modifiedActivityData.supported_locales) !== null && _a !== void 0 ? _a : [];
                // Format updated_at and version_date to exclude time, if they exist
                if ((_b = modifiedActivityData.activity_metadata) === null || _b === void 0 ? void 0 : _b.updated_at) {
                    modifiedActivityData.activity_metadata.updated_at =
                        modifiedActivityData.activity_metadata.updated_at.split('T')[0];
                }
                if ((_c = modifiedActivityData.activity_metadata) === null || _c === void 0 ? void 0 : _c.version_date) {
                    modifiedActivityData.activity_metadata.version_date =
                        modifiedActivityData.activity_metadata.version_date.split('T')[0];
                }
                yield this.session.post(url, { resourceId, activity: modifiedActivityData }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                // TODO: Show a success message to the user
                console.log('Activity saved successfully');
            }
            catch (error) {
                console.error('Error saving activity:', error);
                throw error;
            }
        });
    }
    pushTranslationBundle(resourceId, locales, isCustomEcoa) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = isCustomEcoa ? '/custom_ecoa/v2/localized' : '/instrument_bundler/v2/localized';
            try {
                yield this.session.post(url, { resourceId, locales }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                // TODO: Show a success message to the user
                console.log('Translation bundles pushed to library successfully');
            }
            catch (error) {
                console.error('Error saving translation bundles:', error);
                throw error;
            }
        });
    }
    getScreenReport(resourceId, modality, isCustomEcoa) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = isCustomEcoa ? '/custom_ecoa/screen_report' : '/instrument_bundler/screen_report';
            try {
                const response = yield this.session.post(url, { resourceId, modality }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    responseType: 'blob',
                });
                const contentDisposition = response.headers['content-disposition'];
                let fileName = `${resourceId}-${modality}.pdf`;
                if (contentDisposition) {
                    fileName = this.extractFilenameFromContentDisposition(contentDisposition) || fileName;
                }
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${fileName}`;
                link.click();
                console.log('eCOA screen report PDF generated successfully');
            }
            catch (error) {
                console.error('Error retrieving screen report:', error);
                if (error.response && error.response.data) {
                    error.response.data = JSON.parse(yield error.response.data.text());
                }
                throw error;
            }
        });
    }
    extractFilenameFromContentDisposition(contentDisposition) {
        const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = regex.exec(contentDisposition);
        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '');
        }
        return null;
    }
}
exports.LibraryManager = LibraryManager;
//# sourceMappingURL=library_manager.js.map